module.exports = __webpack_public_path__ + "img/djscs.8c7148af.png";